import React, { useEffect, useState, createContext, useContext } from 'react';
import { LinkedInProfile } from '../utils/linkedInAuth';
import { AccessLevel, getAccessLevel } from '../utils/emailValidation';
export type UserType = 'hiring_manager' | 'recruiter' | 'general' | null;
export type ViewPreference = 'ai' | 'traditional' | null;
interface PortfolioContextType {
  viewPreference: 'traditional' | 'ai';
  setViewPreference: (preference: 'traditional' | 'ai') => void;
  isChatDrawerOpen: boolean;
  openChatDrawer: () => void;
  closeChatDrawer: () => void;
  chatEntryPoint: string | null;
  setChatEntryPoint: (path: string) => void;
  navigatedFromChat: boolean;
  setNavigatedFromChat: (value: boolean) => void;
  previousPage: string | null;
  setPreviousPage: (path: string | null) => void;
}
const PortfolioContext = createContext<PortfolioContextType | undefined>(undefined);
export function PortfolioProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [viewPreference, setViewPreference] = useState<'traditional' | 'ai'>('traditional');
  const [isChatDrawerOpen, setIsChatDrawerOpen] = useState(false);
  const [chatEntryPoint, setChatEntryPoint] = useState<string | null>(null);
  const [navigatedFromChat, setNavigatedFromChat] = useState(false);
  const [previousPage, setPreviousPage] = useState<string | null>(null);
  const openChatDrawer = () => {
    setIsChatDrawerOpen(true);
  };
  const closeChatDrawer = () => {
    setIsChatDrawerOpen(false);
  };
  return <PortfolioContext.Provider value={{
    viewPreference,
    setViewPreference,
    isChatDrawerOpen,
    openChatDrawer,
    closeChatDrawer,
    chatEntryPoint,
    setChatEntryPoint,
    navigatedFromChat,
    setNavigatedFromChat,
    previousPage,
    setPreviousPage
  }} data-id="element-493">
      {children}
    </PortfolioContext.Provider>;
}
export function usePortfolio() {
  const context = useContext(PortfolioContext);
  if (context === undefined) {
    throw new Error('usePortfolio must be used within a PortfolioProvider');
  }
  return context;
}